// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import core from '@bmp-vue/core'
import modules from './plugins/store/modules'

// Components
import './components'

core.carregaEmpresa = false
core.useOIDCAuth = true
core.initialRoute = '/atividade'

const controllers = require.context('@/controllers', true, /\.js$/)
core.methods.init(controllers)

modules.forEach(p => {
  core.store.registerModule(p.name, p)
})

function isApiLoaded() {
  setTimeout(function () {
    if (core.store.getters.loading || core.store.getters.activeRequests > 0) {
      isApiLoaded()
      return false
    }
    
    // const dto = {
    //   parameters: [
    //     { name: 'documentoFederal', value: core.store.getters.user.profile.name }
    //   ]
    // }

    // core.api.Transferencia.GetMeuDinheiroPorDocumentoFederal(dto).then(function (response) {
    //   let saldo = 0

    //   if (response && response.Saldo)
    //     saldo = response.Saldo

    //   core.store.commit("bmpag/balance", saldo.toString())
    // })

    const paths = require('@/plugins/router/paths').default
    const theme = require('@/plugins/vuetify/theme').default
    const App = () => import('./App')
    core.methods.finish(paths, theme, App)
  }, 100)
}

isApiLoaded()
